"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Application = exports.mapRoutes = void 0;
var tslib_1 = require("tslib");
var queryString = require("query-string");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_router_dom_v5_compat_1 = require("react-router-dom-v5-compat");
var bernie_core_1 = require("bernie-core");
var _1 = require(".");
var loading_spinner_1 = require("./loading-spinner");
var bernie_core_2 = require("bernie-core");
var render_status_1 = require("./render-status");
var experiment_context_1 = require("@shared-ui/experiment-context");
var page_context_1 = require("@bernie/page-context");
var react_1 = require("react");
var routeChangeCallback = function (platformAnalytics) {
  platformAnalytics === null || platformAnalytics === void 0 ? void 0 : platformAnalytics.resetAnalyticsForNewPage();
};
// Maps the controller data to the react-router-dom Rotues or react-router-dom-v5-compat CompatRoutes
var mapRoutes = function (controllers, location) {
  var query = queryString.parse(location.search || '');
  //Double & symbols result in an erroneous 'empty string' key.
  delete query[''];
  var routes = [];
  var buildProxyProps = function (route, path) {
    return {
      path: path,
      exact: route.exact || false,
      caseSensitive: route.caseSensitive || false,
      render: function (props) {
        var _a;
        var Component = route.component;
        var location = tslib_1.__assign(tslib_1.__assign({}, props === null || props === void 0 ? void 0 : props.location), {
          params: (props === null || props === void 0 ? void 0 : props.match) && ((_a = props === null || props === void 0 ? void 0 : props.match) === null || _a === void 0 ? void 0 : _a.params) || {},
          query: query
        });
        return React.createElement(Component, tslib_1.__assign({
          loadingState: React.createElement(loading_spinner_1.LoadingSpinner, null),
          route: route
        }, props, {
          location: location,
          history: props.history
        }));
      }
    };
  };
  controllers.forEach(function (route, index) {
    if (Array.isArray(route.path)) {
      routes.push.apply(routes, tslib_1.__spreadArray([], tslib_1.__read(route.path.map(function (path) {
        return !route.useV5RoutePaths_deprecated ? React.createElement(react_router_dom_v5_compat_1.CompatRoute, tslib_1.__assign({}, buildProxyProps(route, path), {
          key: route.routeName || index
        })) : React.createElement(react_router_dom_1.Route, tslib_1.__assign({}, buildProxyProps(route, path), {
          key: route.routeName || index
        }));
      })), false));
    } else {
      routes.push(!route.useV5RoutePaths_deprecated ? React.createElement(react_router_dom_v5_compat_1.CompatRoute, tslib_1.__assign({}, buildProxyProps(route, route.path), {
        key: route.routeName || index
      })) : React.createElement(react_router_dom_1.Route, tslib_1.__assign({}, buildProxyProps(route, route.path), {
        key: route.routeName || index
      })));
    }
  });
  return routes;
};
exports.mapRoutes = mapRoutes;
exports.Application = (0, bernie_core_1.logger)('Application')(function (props) {
  var _a;
  /**
   * Escape hatch fallback content. In the event that the application breaks on initial hydration,
   * there is an issue where the app will end up with a blank DOM because React already cleared it.
   * This is a placeholder for content to replace the DOM in the event the error occurs.
   * This will allow the page to still be rendered for the user and allow them to progress.
   *
   * @static
   * @type {string}
   * @memberof Application
   */
  exports.Application.fallbackContent = '';
  var markName = 'PWA Mounted';
  var logger = props.logger,
    analytics = props.analytics;
  var performanceMetrics = typeof (analytics === null || analytics === void 0 ? void 0 : analytics.getPlatformAnalytics) === 'function' ? analytics.getPlatformAnalytics().getPerformanceMetrics() : null;
  var startTime;
  if (performanceMetrics) {
    startTime = (_a = performanceMetrics === null || performanceMetrics === void 0 ? void 0 : performanceMetrics.findMark(markName)) === null || _a === void 0 ? void 0 : _a.startTime;
    performanceMetrics === null || performanceMetrics === void 0 ? void 0 : performanceMetrics.mark(markName);
  }
  if (typeof window !== 'undefined') {
    var content = document.getElementById(props.applicationContainerId);
    exports.Application.fallbackContent = content ? content.innerHTML : '';
  }
  // This logger should be a ClientLogger that contains a performance function
  // It is normally provided through bernie-client, but this module doesn't have
  // a dependency on bernie-client, so we have to validate the logger includes
  // the `performance` function
  (0, react_1.useEffect)(function () {
    if (startTime && logger['performance']) {
      logger['performance']({
        hydration: startTime
      });
    }
  });
  var pageDataContext = (0, page_context_1.usePageData)().pageDataContext;
  var firstRender = (0, react_1.useRef)(true);
  (0, react_1.useEffect)(function () {
    // Avoid running this useEffect on first render
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    var nextLocation = props.location || {};
    routeChangeCallback(analytics);
    var nextController = (0, bernie_core_2.matchRoute)(props.routes, nextLocation.pathname, {
      baseUrl: pageDataContext.baseUrl
    });
    pageDataContext.pageId = nextController.route ? nextController.route.pageId : '';
  }, [props.location.pathname]);
  return React.createElement(_1.ErrorBoundary, {
    logger: logger,
    label: 'app.render.errorboundary',
    fallback: fallback
  }, React.createElement(experiment_context_1.Experiment, {
    name: "1DL_EXPEDIA"
  }, React.createElement(experiment_context_1.ExperimentControl, null), React.createElement(experiment_context_1.ExperimentVariant, {
    bucket: 1
  })), React.createElement(_1.LayerManager, null, React.createElement(react_router_dom_1.Switch, null, (0, exports.mapRoutes)(props.routes, props.location))), React.createElement(render_status_1.RenderStatus, null));
  function fallback() {
    var fallbackProps = {
      dangerouslySetInnerHTML: {
        __html: exports.Application.fallbackContent
      }
    };
    return React.createElement("div", tslib_1.__assign({}, fallbackProps));
  }
});